module.exports = __webpack_public_path__ + "img/qr_zs.3a3fcff3.png";